import { ROUTE_BLOCKAGE_DETAIL_CLOSE, ROUTE_BLOCKAGE_DETAIL_OPEN } from '../actions/routeBlockageDetail';

const ACTION_HANDLERS = {
  [ROUTE_BLOCKAGE_DETAIL_OPEN]: (state, action) => ({ ...state, id: action.payload }),
  [ROUTE_BLOCKAGE_DETAIL_CLOSE]: state => ({ ...state, id: null }),
};

const initialState = { id: null };

const routeBlockageDetailReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};

export default routeBlockageDetailReducer;
